import { Component } from '@angular/core';
import { RiskManagementTableService } from '../../services/risk-management.service';

@Component({
  selector: 'route-map-detail-pop-up',
  templateUrl: './route-map-detail-pop-up.component.html',
  styleUrls: ['./route-map-detail-pop-up.component.less']
})

export class RouteMapDetailComponent  {

  declarationId: any = 0;
  containerNo: any = "";
  data: any = {};
  historyDetailComponent: RouteMapDetailComponent;
  loading: boolean;
  followedPathArray : google.maps.LatLngLiteral[]= [];
  shortestPathArray : google.maps.LatLngLiteral[]= [];
  isVisible = false;


  title = 'angular-map-app';
  center: google.maps.LatLngLiteral = {"lat": 24, "lng": 12};
  zoom = 4;

  shortestPathOptions : google.maps.PolylineOptions = {
    strokeColor:"green"
  }

  followedPathOptions : google.maps.PolylineOptions = {
    strokeColor:"red"
  }


  constructor( private clientService: RiskManagementTableService) { }


  openDialogue(declarationId:any, containerNo:any) {
    this.isVisible = true;
    this.loading = true;
    this.declarationId = declarationId;
    this.containerNo = containerNo;
    this.loadData();
  }

  closeDialogue() {
    this.isVisible = false;
  }

  loadData() {
    this.clientService.containerRoute(this.declarationId, this.containerNo).subscribe((response:any) => {
      this.followedPathArray = [];
      this.shortestPathArray = [];
      if (response.followedPathCoordinatesStr != undefined) {
        const followedPathCoordinatesArray = JSON.parse(response.followedPathCoordinatesStr);
        let index = 0;
        for (const coordinates of followedPathCoordinatesArray) {
          if(index == 0){
            this.center.lat =coordinates[0];
            this.center.lng = coordinates[1];
          }
          this.followedPathArray.push({ 'lat': coordinates[0], 'lng': coordinates[1] })

          index++;
        }
      }
      if (response.shortestPathCoordinatesStr != undefined) {
        const shortestPathCoordinatesArray = JSON.parse(response.shortestPathCoordinatesStr);
        for (const coordinates of shortestPathCoordinatesArray) {
          this.shortestPathArray.push({ 'lat': coordinates[0], 'lng': coordinates[1] })
        }
      }

    });

  }

}
